import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfAverageDigitalIntensityScoreEntity } from '../../../core/domain/entities/scores/self-average-digital-intensity-score.entity';

export interface ISelfAverageDigitalIntensityScorePersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.TotalDuration]: string;
  [IWorkingSessionsAnalyticsActivityEnum.TotalActivityDuration]: string;
}

export class SelfAverageDigitalIntensityScoreMapper
  implements
    Omit<Mapper<SelfAverageDigitalIntensityScoreEntity, any>, 'toResponse'>
{
  toDomain(
    record: ISelfAverageDigitalIntensityScorePersistenceResponse
  ): SelfAverageDigitalIntensityScoreEntity {
    return SelfAverageDigitalIntensityScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfAverageDigitalIntensityScorePersistenceResponse
  ): SelfAverageDigitalIntensityScoreEntity {
    const entity = SelfAverageDigitalIntensityScoreEntity.create({
      totalDuration: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalDuration]
      ),
      totalActivityDuration: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalActivityDuration]
      ),
    });
    return entity;
  }
}
